export enum OrderBy {
  ascending = 'ascending',
  descending = 'descending',
}
